import React, { useEffect, useState } from 'react'
import axiosInstance from '../../utils/Api'
import './faq.css'

const Faq = () => {
    const [openFaq, setOpenFaq] = useState(null);
    const [faqData, setFaqData] = useState(() => [
        {
            question: "What is the Magik Mat?",
            answer: "The Magik Mat is a playing while learning device with two sides, one with alphabets and the other with numbers, colours and shapes. Both sides include a Start, Restart and Walkable Space."
        },
        {
            question: "What symbols and features are included on the Magik Mat?",
            answer: "The mat includes alphabets, numbers, arithmetic symbols and shapes. These elements are used based on the educational game being played."
        },
        {
            question: "How is the Magik Mat powered?",
            answer: "The Magik Mat operates using a power bank, which should be disconnected after each use."
        },
        {
            question: "How do I connect the Magik Mat?",
            answer: "Plug the power bank into the red-colored box’s power supply port on the mat. A static red light indicates power is being supplied. Place the power bank in the pouch near the port. A blinking green light means the mat is ready for pairing. Pair your Android device with the Magik Mat. A static green light confirms successful Bluetooth connectivity."
        },
        {
            question: "How do I start playing on the Magik Mat?",
            answer: "Open the Magik Mat application. Select a game. Follow the on-screen instructions. Begin at the START space. Jump on the mat according to the audio-visual instructions. Move between tiles using the WALKABLE SPACE. To restart the game, jump on the RESTART space."
        },
        {
            question: "What should I do if I have Bluetooth issues?",
            answer: "Hold the Reset button next to the green light for 15 seconds to resolve connectivity problems."
        },
        {
            question: "How do I access the Magik Mat’s educational games?",
            answer: "Use the credentials from the user manual to log in and enjoy the audio-visual edutainment games."
        },
        {
            question: "What learning modules are available on the Magik Mat?",
            answer: "Magik Mat has two main game modules: Alphabet Mat and Number Mat."
        },
        {
            question: "What games are included in the Alphabet Mat module?",
            answer: "The Alphabet Mat has three sub-sections: Reading Foundation – Alphabet identification and memory-based educational games; Word Games – Word recognition and spelling games; Fun Learning – General knowledge, interactive puzzles, and engaging games."
        },
        {
            question: "What games are included in the Number Mat module?",
            answer: "The Number Mat includes: Early Math – Number identification and counting games; Arithmetic – Addition, subtraction, and multiplication fun; Math with Logic – Brain teasers and problem-solving challenges; Integrated Learning – General knowledge, fun activities, and social-emotional skill-building."
        },
        {
            question: "What additional entertainment games does the Magik Mat offer?",
            answer: "The mat includes games like Play Music, Peppy’s Choice and Car Race."
        },
        {
            question: "What additional SEL games does the Magik Mat offer?",
            answer: "The mat includes games like Safe Spots, Good Touch Bad Touch and many more."
        },
        {
            question: "How much weight can it handle?",
            answer: "Magik Mat can easily support up to 100 kg."
        },
        {
            question: "How many children can play on the mat at a time?",
            answer: "Two children can play simultaneously."
        },
        {
            question: "Can we connect the mat to a power source other than a power bank?",
            answer: "You must not give direct power to the mat. For safety, the Magik Mat is designed to be powered only by a power bank."
        },
        {
            question: "What should I do if Bluetooth is not showing in the Magik Mat?",
            answer: "Ensure your Bluetooth driver is updated to the latest version manually or through the device manager."
        },
        {
            question: "How do I connect Magik Mat via Bluetooth?",
            answer: "Turn on Bluetooth and search for the Magik Mat BT Code to establish the connection."
        },
        {
            question: "What should I do if the Magik Mat is not taking inputs to the game?",
            answer: "Power off both the Mat and the TV for 15 seconds, then turn them back on and try again. If the problem still persists, call the customer care number mentioned in the user manual or warranty card."
        },
        {
            question: "What should I do if the content is not loading on Android TV?",
            answer: "Check the Bluetooth connection between the Magik Mat and the TV. Ensure the mat is properly paired."
        },
        {
            question: "Can I use the Magik Mat on multiple devices?",
            answer: "The Magik Mat is designed to pair with one device at a time via Bluetooth. To use it with another device, you must disconnect and re-pair it."
        },
        {
            question: "The Magik Mat is not responding to my jumps. What should I do?",
            answer: "Try these steps: \n\n1.Check if the Bluetooth connection is active(static green light).\n\n2.Restart the application and try again.\n\n3.Ensure you are standing in the correct START position.\n\n4.If the issue persists, reset the Magik Mat by holding the Reset button for 15 seconds."
        },
        {
            question: "The game is freezing or lagging. What can I do?",
            answer: "Close the application and reopen it. If the problem continues, clear cache data from the app settings."
        },
        {
            question: "How do I properly store the Magik Mat?",
            answer: "To ensure long-lasting use:\n\n1. Fold the mat as instructed instead of rolling it to prevent creases.\n\n2. Keep it away from water and extreme temperatures.\n\n3. Disconnect the power bank after each use."
        },
        {
            question: "How often should I charge the power bank?",
            answer: "Charge the power bank fully before use. Disconnect after every session to prolong battery life."
        },
        {
            question: "Can multiple players use the Magik Mat at the same time?",
            answer: "While the mat is designed for one player at a time, you can take turns playing games for a fun group activity!"
        },
        {
            question: "What if I accidentally step on the wrong tile?",
            answer: "The game recognizes correct inputs, so stepping on a wrong tile won’t progress the game. Simply step back and try again."
        }
    ]);

    useEffect(() => {
        let isMounted = true

        axiosInstance.get("online/faqs", { timeout: 10000 })
            .then(({ data }) => {
                const incomingFaqs = data?.data
                const hasValidFaqs = Array.isArray(incomingFaqs)
                    && incomingFaqs.length > 0
                    && incomingFaqs.every(faq =>
                        typeof faq?.question === "string" && typeof faq?.answer === "string"
                    )

                if (isMounted && data?.status === true && hasValidFaqs) {
                    setFaqData(incomingFaqs)
                }
            })
            .catch((error) => {
                console.error("Failed to load FAQs. Using default FAQ data.", error)
            })

        return () => {
            isMounted = false
        }
    }, []);

    const toggleAccordion = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };
    return (
        <div>
            <div className='faqMain'>
                <div className='faqWrap'>
                    <h2 className='faqTitle'>Frequently Asked Questions</h2>
                    <div className='faqDetails'>
                        {faqData.map((item, index) => (
                            <div key={index} className='faqItem'>
                                <div className='faqQuestion' onClick={() => toggleAccordion(index)}>
                                    {item.question}
                                    <span>{openFaq === index ? '-' : '+'}</span>
                                </div>
                                {openFaq === index && (
                                    <div className='faqAnswer' style={{ whiteSpace: "pre-line" }}>{item.answer}</div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Faq